<script lang="ts">
import type { PlaceholderAvatarProps } from '../PlaceholderAvatar.vue'

export type MarketMakerAvatarProps = PlaceholderAvatarProps
</script>

<script setup lang="ts">
import placeholder from '../assets/market-maker.png'
import PlaceholderAvatar from '../PlaceholderAvatar.vue'

const props = withDefaults(defineProps<MarketMakerAvatarProps>(), {
  size: 'sm',
})
</script>

<template>
  <PlaceholderAvatar v-bind="props" :placeholder="placeholder" />
</template>
